import { useCallback, useState } from 'react'

function useCardMenu({ id, itemName, onSetAsMain: handleSetAsMain, onDelete: handleDelete }) {
  const [shouldCloseDropdown, setShouldCloseDropdown] = useState(false)
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false)

  const handleSetAsMainClick = useCallback(() => {
    setShouldCloseDropdown(true)
    handleSetAsMain(id, itemName)
  }, [handleSetAsMain, id, itemName])

  const handleOpenDelete = useCallback(() => {
    setShouldCloseDropdown(true)
    setIsDeleteModalOpen(true)
  }, [])

  const handleCloseDelete = useCallback(() => {
    setIsDeleteModalOpen(false)
  }, [])

  const handleConfirmDelete = useCallback(() => {
    handleDelete(id, itemName)
    setIsDeleteModalOpen(false)
  }, [handleDelete, id, itemName])

  return {
    shouldCloseDropdown,
    setShouldCloseDropdown,
    isMenuOpen,
    setIsMenuOpen,
    isDeleteModalOpen,
    handleSetAsMainClick,
    handleOpenDelete,
    handleCloseDelete,
    handleConfirmDelete,
  }
}

export default useCardMenu
